import styled, { css } from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ theme }) => css`
    gap: ${theme.spacings.base};
  `}
`;

export const RowParamBlock = styled.div`
  display: flex;
  align-self: stretch;
  width: 100%;
  margin-bottom: 8px;
`;

export const Title = styled.div`
  color: #495466;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;

  min-width: 248px;
  padding: 10px 0;
`;
